/**
 * auth state から安定なセッションキーを生成する。uid が無ければ null。
 * features は順序差を吸収するためソートして連結する。
 */
export function buildSsoSessionKey(input) {
    if (!input.uid)
        return null;
    const features = [...input.features].sort().join(',');
    return [
        input.uid,
        input.role ?? '',
        input.tenantId ?? '',
        features,
        input.readOnly ? '1' : '0',
        input.impersonatedBy ?? '',
    ].join('|');
}
//# sourceMappingURL=ssoSession.js.map